/**
 * get the display title for a part type
 */
export const getPartTypeTitle = (partType: string): string => {
  const titles = {
    AB: "Part A/B",
    C: "Part C",
    D: "Part D",
  };
  return titles[partType as keyof typeof titles] ?? "Part A/B";
};

/**
 * Label for a Part C/D directory company (Medicare Advantage / Part D plan).
 *
 * Many plans share a legal entity name, so the CMS contract number is appended
 * to make the option unambiguous, e.g. "Aetna Better Health of Michigan Inc. (H2056)".
 */
export const formatDirectoryCompanyLabel = ({
  legal_entity_name,
  contract_number,
}: {
  legal_entity_name: string;
  contract_number?: string | null;
}): string => {
  const name = legal_entity_name.trim();
  const contractNumber = contract_number?.trim();

  return contractNumber ? `${name} (${contractNumber})` : name;
};
